import {Injectable} from '@angular/core';
import {PublicProfile, UserRole} from '@emma-labs/shared/typescript';
import {first, Observable, of, switchMap} from 'rxjs';
import {AgentApiService} from './agent-api.service';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  constructor(
    private api: AgentApiService,
    private authService: AuthService,
  ) {}

  getAgentsFromIds(agentIds: string[]): Observable<{id: string; insurerCode: string; fullName: string}[]> {
    if (agentIds.length === 0) {
      return of([]);
    }

    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      switchMap((session) => this.api.getAgentsFromIds(session.id, agentIds)),
    );
  }

  getPublicProfilesByRoles(roles: UserRole[]): Observable<PublicProfile[]> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      switchMap((session) => this.api.getPublicProfilesByRoles(session.id, roles)),
    );
  }
}
